import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 8,
    marginTop: 8,
    marginBottom: 16
  },

  top: { padding: theme.spacing(2) },
  bottom: {
    padding: theme.spacing(2),
    display: 'grid',
    gap: theme.spacing(1),
    gridTemplateColumns: '1fr 1fr 1fr 0.5fr',
    alignItems: 'flex-end'
  },
  single: {
    gridTemplateColumns: '1fr 1fr 1fr'
  },

  blackText: {
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  btn: { height: '62%' },
  btnText: { color: theme.palette.primary.contrastText }
}))
